/** Deterministic shuffle so each attempt keeps a stable order for the same seed. */

function hashStringToSeed(s: string): number {
  let h = 2166136261 >>> 0;
  for (let i = 0; i < s.length; i++) {
    h ^= s.charCodeAt(i);
    h = Math.imul(h, 16777619);
  }
  return h >>> 0;
}

function mulberry32(initial: number) {
  let a = initial;
  return function next() {
    let t = (a += 0x6d2b79f5);
    t = Math.imul(t ^ (t >>> 15), t | 1);
    t ^= t + Math.imul(t ^ (t >>> 7), t | 61);
    return ((t ^ (t >>> 14)) >>> 0) / 4294967296;
  };
}

export function shuffleWithSeed<T>(items: readonly T[], seedStr: string): T[] {
  if (items.length <= 1) return [...items];
  const rand = mulberry32(hashStringToSeed(seedStr));
  const a = [...items];
  for (let i = a.length - 1; i > 0; i--) {
    const j = Math.floor(rand() * (i + 1));
    const t = a[i]!;
    a[i] = a[j]!;
    a[j] = t;
  }
  return a;
}

/** Scenario blocks from `groupByScenario`-style layout: shuffle inside each block, then shuffle block order. */
export function shuffleScenarioQuestionGroups<G extends { scenario: { id?: string } | null; questions: unknown[] }>(
  groups: G[],
  attemptId: string,
  examKey: string,
): G[] {
  if (!attemptId) return groups;
  const withShuffledQuestions = groups.map((g, gi) => ({
    ...g,
    questions: shuffleWithSeed(
      g.questions as readonly unknown[],
      `${attemptId}:${examKey}:${g.scenario?.id ?? "none"}:intra:${gi}`,
    ) as G["questions"],
  }));
  if (withShuffledQuestions.length <= 1) return withShuffledQuestions as G[];
  return shuffleWithSeed(withShuffledQuestions, `${attemptId}:${examKey}:groups`) as G[];
}
